import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable @typescript-eslint/no-floating-promises */
import { useCallback } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIButton from 'UIComponents/button/UIButton'; // @ts-expect-error Could not find a declaration file for module

import OutlinedHeartIcon from '../../../components/Icons/OutlinedHeartIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { usePlaylistSaveStatus } from '..';
const FullWidthButton = styled(UIButton).withConfig({
  displayName: "SavePlaylistsToggleIcon__FullWidthButton",
  componentId: "sc-17whuqe-0"
})(["width:100%;justify-content:space-between;display:flex;"]);
export const SavePlaylistsToggleIconMessage = ({
  isSaved,
  isOwner
}) => isSaved ? isOwner ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.savedHoverOwner"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.savedHover"
}) : isOwner ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.unsavedHoverOwner"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.unsavedHover"
});

const SavePlaylistsToggleIcon = ({
  playlistId,
  width = '24px',
  useFullButton = false
}) => {
  const {
    isSaved,
    isOwner,
    isLoading,
    togglePlaylistSaveStatus
  } = usePlaylistSaveStatus(playlistId);
  const onClick = useCallback(e => {
    e.stopPropagation();
    e.preventDefault();
    togglePlaylistSaveStatus();
  }, [togglePlaylistSaveStatus]);
  if (isLoading) return null;

  if (useFullButton) {
    return /*#__PURE__*/_jsxs(FullWidthButton, {
      onClick: onClick,
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(SavePlaylistsToggleIconMessage, {
        isOwner: isOwner,
        isSaved: isSaved
      }), /*#__PURE__*/_jsx(OutlinedHeartIcon, {
        isFilled: isSaved,
        style: {
          width: '24px'
        }
      })]
    });
  }

  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(SavePlaylistsToggleIconMessage, {
      isOwner: isOwner,
      isSaved: isSaved
    }),
    children: /*#__PURE__*/_jsx(UIButton, {
      onClick: onClick,
      style: {
        width,
        padding: '1px'
      },
      use: "unstyled",
      children: /*#__PURE__*/_jsx(OutlinedHeartIcon, {
        isFilled: isSaved
      })
    })
  });
};

export default SavePlaylistsToggleIcon;